document.addEventListener('click', event => {
  const element = event.target

  if (element.dataset.behavior && element.dataset.behavior.includes('scroll-into-view')) {
    event.preventDefault()
    const href = element.getAttribute('href').slice(1)
    document.getElementById(href).scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
}, false)
